export const SIGN_IN = 'auth/SIGN_IN'
export const SIGN_IN_ERROR = 'auth/SIGN_IN_ERROR'
export const CHECK_AUTH = 'auth/CHECK_AUTH'

export const LOG_OUT_REQUEST = 'auth/LOG_OUT_REQUEST'
export const LOG_OUT_SUCCESS = 'auth/LOG_OUT_SUCCESS'
export const LOG_OUT_ERROR = 'auth/LOG_OUT_ERROR'
